import React, { useState } from "react"
import PropTypes from "prop-types"
import {
  Row,
  Col,
  CardBody,
  Card,
  Container,
  Form,
  Input,
  FormFeedback,
  Label,
  InputGroupText,
  InputGroup,
} from "reactstrap"
import { Link, useNavigate } from "react-router-dom"

import profile from "assets/images/logo.png"
import logo from "assets/images/main-logo.png"

import "../../assets/css/Login/Login.css"
import Configs from "../../config"
import secureLocalStorage from "react-secure-storage"
import { FetchPostData } from "utils/Common_api_functions"
import Swal from "sweetalert2"
import Loader from "components/Loader/Loader"
import { IoMdEye, IoMdEyeOff } from "react-icons/io"
import { FaLock } from "react-icons/fa"

const Login = () => {
  const navigate = useNavigate()
  document.title = "Login | Vintage Infra Equipment Sol PVT LTD"

  // ------------------ STATES -------------------
  const [loading, setLoading] = useState(false)
  const [formData, setFormData] = useState({
    phone: "",
    password: "",
  })

  const [errors, setErrors] = useState({})

  const [showPassword, setShowPassword] = useState(false)

  const togglePassword = () => {
    setShowPassword(prev => !prev)
  }

  // ------------------ HANDLERS -------------------
  const handleChange = e => {
    const { name, value } = e.target

    setFormData(prev => ({
      ...prev,
      [name]: value,
    }))
  }

  const validate = () => {
    const errs = {}

    if (!formData.phone) {
      errs.phone = "Phone number is required"
    } else if (!/^[6-9]\d{9}$/.test(formData.phone)) {
      errs.phone = "Enter a valid 10-digit phone number"
    }

    if (!formData.password) {
      errs.password = "Password is required"
    } else if (formData.password.length < 6) {
      errs.password = "Password must be at least 6 characters"
    }

    return errs
  }

  const handleSubmit = async e => {
    e.preventDefault()

    const validationErrors = validate()

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors)
      return
    }

    const APIData = await FetchPostData(setLoading, "auth/login", {
      key: formData?.phone,
      password: formData?.password,
    })

    if (APIData?.data?.success) {
      Swal.fire({
        title: "Login Successfull",
        text: APIData?.data?.message,
        icon: "success",
        timer: 1000,
      })
      secureLocalStorage?.setItem("admin_user", APIData?.data?.data)
      secureLocalStorage?.setItem("auth_token", APIData?.data?.token)
      navigate(`${Configs.appurl}dashboard`)
    } else {
      Swal.fire({
        title: "Login Unsuccessfull",
        text: APIData?.response?.data?.message,
        icon: "error",
      })
    }
  }

  return (
    <React.Fragment>
      {loading && <Loader />}
      <div className="login-page">
        <div className="account-pages">
          <Container>
            <Row className="justify-content-center">
              <Col md={9} lg={6} xl={5}>
                <Card className="overflow-hidden rounded-5 py-4 login-card">
                  <CardBody className="pt-0">
                    <div className="login-card1 d-flex justify-content-center rounded-4 p-2">
                      <img
                        src={logo}
                        alt="Login Illustration"
                        className="img-fluid w-50 object-fit-cover"
                      />
                    </div>
                    <div className="text-center">
                      <Link
                        to={`${Configs.appurl}`}
                        className="logo-light-element"
                      >
                        <div className="avatar-md profile-user-wid mb-4">
                          <span className="avatar-title rounded-circle bg-light">
                            <img
                              src={logo}
                              alt="Logo"
                              className="rounded-circle"
                              height="34"
                            />
                          </span>
                        </div>
                      </Link>
                    </div>

                    <div className="p-2 mt-4">
                      <Form onSubmit={handleSubmit}>
                        <div className="mb-4">
                          <Label className="label">
                            Phone Number <span className="text-danger">*</span>
                          </Label>

                          <Input
                            name="phone"
                            type="tel"
                            placeholder="Enter phone number"
                            value={formData.phone}
                            onChange={handleChange}
                            maxLength={10}
                            className="form-control1"
                          />

                          {errors.phone && (
                            <span className="text-danger">{errors.phone}</span>
                          )}
                        </div>

                        <div className="mb-4" style={{ position: "relative" }}>
                          <Label className="label">
                            Password <span className="text-danger">*</span>
                          </Label>

                          <Input
                            name="password"
                            type={showPassword ? "text" : "password"}
                            placeholder="Enter password"
                            value={formData.password}
                            onChange={handleChange}
                            style={{
                              paddingRight: "40px",
                            }} // padding for icon
                            className="form-control1"
                          />

                          {/* Eye Icon inside Input */}
                          <span
                            onClick={togglePassword}
                            style={{
                              position: "absolute",
                              right: "12px",
                              top: "68%",
                              transform: "translateY(-50%)",
                              cursor: "pointer",
                              color: "#6c757d",
                            }}
                          >
                            {showPassword ? (
                              <IoMdEye size={18} />
                            ) : (
                              <IoMdEyeOff size={18} />
                            )}
                          </span>

                          {errors.password && (
                            <span className="text-danger">
                              {errors.password}
                            </span>
                          )}
                        </div>

                        {/* <div className="d-flex justify-content-end mb-3">
                          <div>
                            <Link
                              to={"/forgot-password"}
                              className="text-white fw-bold"
                            >
                              <FaLock className="me-2" />
                              Forgot Password ?
                            </Link>
                          </div>
                        </div> */}

                        <div className="mt-3 d-grid">
                          <button
                            type="submit"
                            className="btn btn-blue text-white btn-block rounded-4"
                          >
                            Log In
                          </button>
                        </div>
                      </Form>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </React.Fragment>
  )
}

Login.propTypes = {
  history: PropTypes.object,
}

export default Login
